import { Box, Typography } from "@mui/material";

const resolveSectionStyle = (value) =>
  String(value || "").trim().toLowerCase() === "dark" ? "dark" : "light";

export default function DocumentSectionTitle({ title = "", style = "light" }) {
  const normalizedTitle = String(title || "").trim();
  if (!normalizedTitle) return null;

  const normalizedStyle = resolveSectionStyle(style);
  const isDark = normalizedStyle === "dark";

  return (
    <Box
      data-section-style={normalizedStyle}
      sx={{
        width: "100%",
        pt: 0,
        pb: isDark ? 0 : 0.5,
        px: isDark ? 1.5 : 0,
        py: isDark ? 1 : undefined,
        bgcolor: isDark ? "#000" : "transparent",
        color: isDark ? "#fff" : "text.primary",
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 800,
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          mb: 0,
          color: "inherit",
        }}
      >
        {normalizedTitle.toUpperCase()}
      </Typography>
    </Box>
  );
}
